// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ExternalNetworkScanTypeSchema = z.enum(['RECON','DISCOVERY','CVE_RETEST','VULNERABILITY'] as const);

export type ExternalNetworkScanTypeType = `${z.infer<typeof ExternalNetworkScanTypeSchema>}`

export default ExternalNetworkScanTypeSchema;
